import { render, staticRenderFns } from "./carousel-articles.vue?vue&type=template&id=87d04772&scoped=true&"
import script from "./carousel-articles.vue?vue&type=script&lang=ts&"
export * from "./carousel-articles.vue?vue&type=script&lang=ts&"
import style0 from "./carousel-articles.vue?vue&type=style&index=0&id=87d04772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d04772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCarousel,VCarouselItem,VTab,VTabs})
